/**
 * Global status banner — reads configuration injected at build time
 * via statusMessageConfig and displays a dismissable info / warning / success message.
 */
(function () {
  var STORAGE_KEY = "status-banner-dismissed";
  var VALID_TYPES = ["info", "warning", "success"];

  var banner = document.getElementById("status-banner");
  if (!banner || typeof statusMessageConfig === "undefined") return;

  var config = statusMessageConfig;
  if (!config || !config.enabled || !config.message) return;

  var type = VALID_TYPES.indexOf(config.type) !== -1 ? config.type : "info";

  // Check if user previously dismissed this exact message
  try {
    var dismissed = sessionStorage.getItem(STORAGE_KEY);
    if (dismissed === config.message) return;
  } catch (e) {
    console.error("Failed to read status banner dismissal:", e);
  }

  // Render
  var messageEl = document.getElementById("status-banner-message");
  messageEl.textContent = config.message;

  // Optional link appended after the message text
  if (config.link_url) {
    var url = String(config.link_url);
    var isSafeUrl = url.charAt(0) === "/" || url.indexOf("./") === 0 || url.indexOf("http://") === 0 || url.indexOf("https://") === 0;
    if (!isSafeUrl) {
      console.warn("Ignoring unsafe status banner link_url:", url);
    } else {
      var sep = document.createTextNode(" ");
      var link = document.createElement("a");
      link.setAttribute("href", url);
      link.textContent = config.link_text || "Learn more";
      messageEl.appendChild(sep);
      messageEl.appendChild(link);
    }
  }

  banner.classList.add("status-banner--" + type);
  banner.style.display = "";

  // Dismiss button
  if (config.dismissable) {
    var dismissBtn = document.getElementById("status-banner-dismiss");
    dismissBtn.style.display = "";
    dismissBtn.addEventListener("click", function () {
      banner.style.display = "none";
      try {
        sessionStorage.setItem(STORAGE_KEY, config.message);
      } catch (e) {
        console.error("Failed to save status banner dismissal:", e);
      }
    });
  }
})();
